import { auth as enUS_auth } from './en-US/auth';
import { autoria as enUS_autoria } from './en-US/autoria';
import { busca as enUS_busca } from './en-US/busca';
import { catalogo as enUS_catalogo } from './en-US/catalogo';
import { certificado as enUS_certificado } from './en-US/certificado';
import { common as enUS_common } from './en-US/common';
import { curadoria as enUS_curadoria } from './en-US/curadoria';
import { dashboard as enUS_dashboard } from './en-US/dashboard';
import { notificacoes as enUS_notificacoes } from './en-US/notificacoes';
import { usuarios as enUS_usuarios } from './en-US/usuarios';
import { auth as ptBR_auth } from './pt-BR/auth';
import { autoria as ptBR_autoria } from './pt-BR/autoria';
import { busca as ptBR_busca } from './pt-BR/busca';
import { catalogo as ptBR_catalogo } from './pt-BR/catalogo';
import { certificado as ptBR_certificado } from './pt-BR/certificado';
import { common as ptBR_common } from './pt-BR/common';
import { curadoria as ptBR_curadoria } from './pt-BR/curadoria';
import { dashboard as ptBR_dashboard } from './pt-BR/dashboard';
import { notificacoes as ptBR_notificacoes } from './pt-BR/notificacoes';
import { usuarios as ptBR_usuarios } from './pt-BR/usuarios';

export const resources = {
  'pt-BR': {
    common: ptBR_common,
    auth: ptBR_auth,
    dashboard: ptBR_dashboard,
    catalogo: ptBR_catalogo,
    certificado: ptBR_certificado,
    busca: ptBR_busca,
    autoria: ptBR_autoria,
    curadoria: ptBR_curadoria,
    usuarios: ptBR_usuarios,
    notificacoes: ptBR_notificacoes,
  },
  'en-US': {
    common: enUS_common,
    auth: enUS_auth,
    dashboard: enUS_dashboard,
    catalogo: enUS_catalogo,
    certificado: enUS_certificado,
    busca: enUS_busca,
    autoria: enUS_autoria,
    curadoria: enUS_curadoria,
    usuarios: enUS_usuarios,
    notificacoes: enUS_notificacoes,
  },
} as const;

export const defaultNS = 'common' as const;
// MVP bilíngue: só pt-BR + en-US (SPEC 8.3 BR-1 / §8 — idiomas além destes fora do MVP).
export const supportedLanguages = ['pt-BR', 'en-US'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];
